import Vue from 'vue'

// Default Menu
import LoginDefault from './main/default/LoginDefault';
import MainMenuDefault from './main/default/MainMenuDefault';
import DashboardDefault from './main/default/DashboardDefault';
import DashboardUserDefault from './main/default/component/DashboardUserDefault';
import DashboardAdminDefault from './main/default/component/DashboardAdminDefault';
Vue.component('FLoginDefault', LoginDefault);
Vue.component('FMainMenuDefault', MainMenuDefault);
Vue.component('FDashboardDefault', DashboardDefault);
Vue.component('FDashboardUserDefault', DashboardUserDefault);
Vue.component('FDashboardAdminDefault', DashboardAdminDefault);

// SUMUT Menu
import LoginSumut from './main/sumut/LoginSumut';
import MainMenuSumut from './main/sumut/MainMenuSumut';
import DashboardSumut from './main/sumut/DashboardSumut';
import DashboardUserSumut from './main/sumut/component/DashboardUserSumut';
import DashboardAdminSumut from './main/sumut/component/DashboardAdminSumut';
Vue.component(LoginSumut.name, LoginSumut);
Vue.component(MainMenuSumut.name, MainMenuSumut);
Vue.component(DashboardSumut.name, DashboardSumut);
Vue.component(DashboardUserSumut.name, DashboardUserSumut);
Vue.component(DashboardAdminSumut.name, DashboardAdminSumut);

// SULTENG Menu
import LoginSulteng from './main/sulteng/LoginSulteng';
import MainMenuSulteng from './main/sulteng/MainMenuSulteng';
import DashboardSulteng from './main/sulteng/DashboardSulteng';
import DashboardUserSulteng from './main/sulteng/component/DashboardUserSulteng';
import DashboardAdminSulteng from './main/sulteng/component/DashboardAdminSulteng';
Vue.component(LoginSulteng.name, LoginSulteng);
Vue.component(MainMenuSulteng.name, MainMenuSulteng);
Vue.component(DashboardSulteng.name, DashboardSulteng);
Vue.component(DashboardUserSulteng.name, DashboardUserSulteng);
Vue.component(DashboardAdminSulteng.name, DashboardAdminSulteng);

// Bengkulu Menu
import LoginBengkulu from './main/bengkulu/LoginBengkulu';
import MainMenuBengkulu from './main/bengkulu/MainMenuBengkulu';
import DashboardBengkulu from './main/bengkulu/DashboardBengkulu';
import DashboardUserBengkulu from './main/bengkulu/component/DashboardUserBengkulu';
import DashboardAdminBengkulu from './main/bengkulu/component/DashboardAdminBengkulu';
Vue.component(LoginBengkulu.name, LoginBengkulu);
Vue.component(MainMenuBengkulu.name, MainMenuBengkulu);
Vue.component(DashboardBengkulu.name, DashboardBengkulu);
Vue.component(DashboardUserBengkulu.name, DashboardUserBengkulu);
Vue.component(DashboardAdminBengkulu.name, DashboardAdminBengkulu);

// Sulut Menu
import LoginSulut from './main/sulut/LoginSulut';
import MainMenuSulut from './main/sulut/MainMenuSulut';
import DashboardSulut from './main/sulut/DashboardSulut';
import DashboardUserSulut from './main/sulut/component/DashboardUserSulut';
import DashboardAdminSulut from './main/sulut/component/DashboardAdminSulut';
Vue.component(LoginSulut.name, LoginSulut);
Vue.component(MainMenuSulut.name, MainMenuSulut);
Vue.component(DashboardSulut.name, DashboardSulut);
Vue.component(DashboardUserSulut.name, DashboardUserSulut);
Vue.component(DashboardAdminSulut.name, DashboardAdminSulut);

// Main
import Menu from './main/Menu';
import Drawer from './main/Drawer';
import Toolbar from './main/Toolbar';
import MenuNavigation from './main/MenuNavigation';
Vue.component(Menu.name, Menu);
Vue.component(Drawer.name, Drawer);
Vue.component(Toolbar.name, Toolbar);
Vue.component(MenuNavigation.name, MenuNavigation);

// Card
import GuideCard from './card/GuideCard';
import TransactionListCard from './card/TransactionListCard';
import InformationAccountCard from './card/InformationAccountCard';
Vue.component(GuideCard.name, GuideCard);
Vue.component(TransactionListCard.name, TransactionListCard);
Vue.component(InformationAccountCard.name, InformationAccountCard);

// Field
import Otpbox from "./field/Otpbox";
import DateBox from './field/Datebox';
import Timebox from "./field/Timebox";
import Decimalbox from './field/Decimalbox';
import Passwordbox from './field/Passwordbox';
import ButtonOption from './field/ButtonOption';
import RadioNationExt from "./field/RadioNationExt";
import RadioResidentExt from "./field/RadioResidentExt";
import RadioTransferExt from "./field/RadioTransferExt";
import RadioDestinationExt from "./field/RadioDestinationExt";
import RadioVirtualAccountType from "./field/RadioVirtualAccountType";
import RadioVirtualAccountOpen from "./field/RadioVirtualAccountOpen";
import RadioVirtualAccountFixed from "./field/RadioVirtualAccountFixed";
import RadioVirtualAccountSingle from "./field/RadioVirtualAccountSingle";
import RadioKasdaType from "./field/RadioKasdaType";
Vue.component(Otpbox.name, Otpbox);
Vue.component(DateBox.name, DateBox);
Vue.component(Timebox.name, Timebox);
Vue.component(Decimalbox.name, Decimalbox);
Vue.component(Passwordbox.name, Passwordbox);
Vue.component(ButtonOption.name, ButtonOption);
Vue.component(RadioNationExt.name, RadioNationExt);
Vue.component(RadioResidentExt.name, RadioResidentExt);
Vue.component(RadioTransferExt.name, RadioTransferExt);
Vue.component(RadioDestinationExt.name, RadioDestinationExt);
Vue.component(RadioVirtualAccountType.name, RadioVirtualAccountType);
Vue.component(RadioVirtualAccountOpen.name, RadioVirtualAccountOpen);
Vue.component(RadioVirtualAccountFixed.name, RadioVirtualAccountFixed);
Vue.component(RadioVirtualAccountSingle.name, RadioVirtualAccountSingle);
Vue.component(RadioKasdaType.name, RadioKasdaType);

// Dialog
import DialogOtp from './dialog/DialogOtp';
import DialogReason from './dialog/DialogReason';
import DialogLogout from './dialog/DialogLogout';
import DialogTimeout from './dialog/DialogTimeout';
import DialogConfirm from './dialog/DialogConfirm';
import DialogFirstLogin from './dialog/DialogFirstLogin';
import DialogChangePassword from './dialog/DialogChangePassword';
Vue.component(DialogOtp.name, DialogOtp);
Vue.component(DialogReason.name, DialogReason);
Vue.component(DialogLogout.name, DialogLogout);
Vue.component(DialogTimeout.name, DialogTimeout);
Vue.component(DialogConfirm.name, DialogConfirm);
Vue.component(DialogFirstLogin.name, DialogFirstLogin);
Vue.component(DialogChangePassword.name, DialogChangePassword);

// Stepper
import TransactionListStepper from './stepper/TransactionListStepper';
Vue.component(TransactionListStepper.name, TransactionListStepper);

// Table
import KasdaDetailTable from './tables/KasdaDetailTable';
import SiskeudesDetailTable from './tables/SiskeudesDetailTable';
import KasdaPotonganTable from './tables/KasdaPotonganTable';
import PemdaPotonganTable from "./tables/PemdaPotonganTable";
import SiskeudesPotonganTable from './tables/SiskeudesPotonganTable';
import AccountCorporateTable from './tables/AccountCorporateTable';
import MerchantCorporateTable from './tables/MerchantCorporateTable';
import InstallmentDetailTable from './tables/InstallmentDetailTable';
import UploadTransactionTable from './tables/UploadTransactionTable';
import PayrollInstanceCorporateTable from './tables/PayrollInstanceCorporateTable';
Vue.component(KasdaDetailTable.name, KasdaDetailTable);
Vue.component(SiskeudesDetailTable.name, SiskeudesDetailTable);
Vue.component(KasdaPotonganTable.name, KasdaPotonganTable);
Vue.component(PemdaPotonganTable.name, PemdaPotonganTable);
Vue.component(SiskeudesPotonganTable.name, SiskeudesPotonganTable);
Vue.component(AccountCorporateTable.name, AccountCorporateTable);
Vue.component(InstallmentDetailTable.name, InstallmentDetailTable);
Vue.component(MerchantCorporateTable.name, MerchantCorporateTable);
Vue.component(UploadTransactionTable.name, UploadTransactionTable);
Vue.component(PayrollInstanceCorporateTable.name, PayrollInstanceCorporateTable);

// Selection
import SelectMap from "./select/SelectMap";
import SelectBank from "./select/SelectBank";
import SelectRole from "./select/SelectRole";
import SelectMonth from "./select/SelectMonth";
import SelectDenom from "./select/SelectDenom";
import SelectBankExt from "./select/SelectBankExt";
import SelectProduct from "./select/SelectProduct";
import SelectPayType from "./select/SelectPayType";
import SelectVaStatus from "./select/SelectVaStatus";
import SelectTreasury from "./select/SelectTreasury";
import SelectAccountType from "./select/SelectAccountType";
import SelectUploadStatus from "./select/SelectUploadStatus";
import SelectProductGroup from "./select/SelectProductGroup";
import SelectJenisSetoran from "./select/SelectJenisSetoran";
import SelectMerchantGroup from "./select/SelectMerchantGroup";
import SelectValidationType from "./select/SelectValidationType";
import SelectGroupCorporate from "./select/SelectGroupCorporate";
import SelectAccountBalance from "./select/SelectAccountBalance";
import SelectTransactionStatus from "./select/SelectTransactionStatus";
import SelectTransactionMerchant from "./select/SelectTransactionMerchant";
Vue.component(SelectMap.name, SelectMap);
Vue.component(SelectBank.name, SelectBank);
Vue.component(SelectRole.name, SelectRole);
Vue.component(SelectMonth.name, SelectMonth);
Vue.component(SelectDenom.name, SelectDenom);
Vue.component(SelectPayType.name, SelectPayType);
Vue.component(SelectProduct.name, SelectProduct);
Vue.component(SelectBankExt.name, SelectBankExt);
Vue.component(SelectVaStatus.name, SelectVaStatus);
Vue.component(SelectTreasury.name, SelectTreasury);
Vue.component(SelectAccountType.name, SelectAccountType);
Vue.component(SelectProductGroup.name, SelectProductGroup);
Vue.component(SelectJenisSetoran.name, SelectJenisSetoran);
Vue.component(SelectUploadStatus.name, SelectUploadStatus);
Vue.component(SelectMerchantGroup.name, SelectMerchantGroup);
Vue.component(SelectGroupCorporate.name, SelectGroupCorporate);
Vue.component(SelectAccountBalance.name, SelectAccountBalance);
Vue.component(SelectValidationType.name, SelectValidationType);
Vue.component(SelectTransactionStatus.name, SelectTransactionStatus);
Vue.component(SelectTransactionMerchant.name, SelectTransactionMerchant);

// Form Config
import SpvForm from './form/config/SpvForm';
import UserForm from './form/config/UserForm';
import GroupForm from './form/config/GroupForm';
import GroupAccountForm from './form/config/GroupAccountForm';
Vue.component(SpvForm.name, SpvForm);
Vue.component(UserForm.name, UserForm);
Vue.component(GroupForm.name, GroupForm);
Vue.component(GroupAccountForm.name, GroupAccountForm);

// Form List
import DefaultListForm from './form/list/DefaultListForm';
import PaymentListForm from './form/list/PaymentListForm';
import PurchaseListForm from './form/list/PurchaseListForm';
import PaymentPstnListForm from './form/list/PaymentPstnListForm';
import PaymentMultiListForm from "./form/list/PaymentMultiListForm";
import TransferOnlineListForm from './form/list/TransferOnlineListForm';
import TransferInternalListForm from './form/list/TransferInternalListForm';
import TransferExternalListForm from './form/list/TransferExternalListForm';
Vue.component(DefaultListForm.name, DefaultListForm);
Vue.component(PaymentListForm.name, PaymentListForm);
Vue.component(PurchaseListForm.name, PurchaseListForm);
Vue.component(PaymentPstnListForm.name, PaymentPstnListForm);
Vue.component(PaymentMultiListForm.name, PaymentMultiListForm);
Vue.component(TransferOnlineListForm.name, TransferOnlineListForm);
Vue.component(TransferInternalListForm.name, TransferInternalListForm);
Vue.component(TransferExternalListForm.name, TransferExternalListForm);
Vue.component(TransferExternalListForm.name, TransferExternalListForm);

// Form Transaction
import BillingForm from './form/transaction/BillingForm';
import ScheduleForm from './form/transaction/ScheduleForm';
Vue.component(BillingForm.name, BillingForm);
Vue.component(ScheduleForm.name, ScheduleForm);

// Form VA
import AdditionalDataForm from "./form/va/AdditionalDataForm";
import VirtualAccountForm from './form/va/VirtualAccountForm';
import LogVirtualAccountForm from './form/va/LogVirtualAccountForm';
Vue.component(AdditionalDataForm.name, AdditionalDataForm);
Vue.component(VirtualAccountForm.name, VirtualAccountForm);
Vue.component(LogVirtualAccountForm.name, LogVirtualAccountForm);

// Content 
import BannerImageContent from './content/BannerImageContent';
import TransactionContent from './content/TransactionContent';
import AccountBalanceContent from './content/AccountBalanceContent';
import AccountStatementContent from './content/AccountStatementContent';
import UploadTransactionContent from './content/UploadTransactionContent';
import DefaultTransactionContent from './content/DefaultTransactionContent';
Vue.component(BannerImageContent.name, BannerImageContent);
Vue.component(TransactionContent.name, TransactionContent);
Vue.component(AccountBalanceContent.name, AccountBalanceContent);
Vue.component(AccountStatementContent.name, AccountStatementContent);
Vue.component(UploadTransactionContent.name, UploadTransactionContent);
Vue.component(DefaultTransactionContent.name, DefaultTransactionContent);

// Content Billing
import BillingContent from './content/billing/BillingContent';
Vue.component(BillingContent.name, BillingContent);

// Content Kasda
import KasdaTransactionContent from './content/kasda/KasdaTransactionContent';
Vue.component(KasdaTransactionContent.name, KasdaTransactionContent);

// Content Siskeudes
import SiskeudesTransactionContent from './content/siskeudes/SiskeudesTransactionContent';
Vue.component(SiskeudesTransactionContent.name, SiskeudesTransactionContent);


// Content Payment
import PaymentContent from './content/payment/PaymentContent';
import PaymentPadContent from "./content/payment/PaymentPadContent";
import PaymentMpnContent from './content/payment/PaymentMpnContent';
import MultiPaymentContent from "./content/payment/MultiPaymentContent";
import MultiPaymentDetailContent from "./content/payment/MultiPaymentDetailContent";
Vue.component(PaymentContent.name, PaymentContent);
Vue.component(PaymentMpnContent.name, PaymentMpnContent);
Vue.component(PaymentPadContent.name, PaymentPadContent);
Vue.component(MultiPaymentContent.name, MultiPaymentContent);
Vue.component(MultiPaymentDetailContent.name, MultiPaymentDetailContent);

// Content Purchase
import PurchaseContent from './content/purchase/PurchaseContent';
import PurchasePlnContent from './content/purchase/PurchasePlnContent';
Vue.component(PurchaseContent.name, PurchaseContent);
Vue.component(PurchasePlnContent.name, PurchasePlnContent);

// Content Pemda
import PemdaTransactionContent from './content/pemda/PemdaTransactionContent';
import PemdaTransactionBulkContent from "./content/pemda/PemdaTransactionBulkContent";
import PemdaTransactionPaymentContent from "./content/pemda/PemdaTransactionPaymentContent";
Vue.component(PemdaTransactionContent.name, PemdaTransactionContent);
Vue.component(PemdaTransactionBulkContent.name, PemdaTransactionBulkContent);
Vue.component(PemdaTransactionPaymentContent.name, PemdaTransactionPaymentContent);

// Content VA
import VirtualAccountContent from './content/va/VirtualAccountContent';
import LogVirtualAccountContent from './content/va/LogVirtualAccountContent';
Vue.component(VirtualAccountContent.name, VirtualAccountContent);
Vue.component(LogVirtualAccountContent.name, LogVirtualAccountContent);

// Content Transfer
import TransferOnlineContent from './content/transfer/TransferOnlineContent';
import TransferInternalContent from './content/transfer/TransferInternalContent';
import TransferExternalContent from './content/transfer/TransferExternalContent';
import MultiTransferInternalContent from './content/transfer/MultiTransferInternalContent';
Vue.component(TransferOnlineContent.name, TransferOnlineContent);
Vue.component(TransferInternalContent.name, TransferInternalContent);
Vue.component(TransferExternalContent.name, TransferExternalContent);
Vue.component(MultiTransferInternalContent.name, MultiTransferInternalContent);

// Content PHRI
import PhriContent from './content/phri/PhriContent';
Vue.component(PhriContent.name, PhriContent);